import styled from "styled-components";
import { MainBox } from "../../../theme/global.styles";
import { CMHeadingContainer } from "../../../components/heading/heading.styles";

export const CMCarouselContainer = styled.div((props) => ({
  width: "40%", 

  [`@media (min-width: 2000px)`]: {
    '& > div > div > div > div > img': { 
      width: "30vh", 
    },
  },

  [`@media ${props.theme.breakpoints.md}`]: {
    '& > div > div > div > div > img': { 
      width: "30vh", 
      height: "auto", 
    },
  },

  [`@media ${props.theme.breakpoints.sm}`]: {
    '& > div > div > div > div > img': { 
      width: "90%", 
      height: "auto", 
    },
  },

  [`@media ${props.theme.breakpoints.xs}`]: {
    '& > div > div > div > div > img': { 
      width: "70%", 
      height: "auto", 
    },
  },
}));


export const CMCardContainer = styled.div`
  width: 40%;
  right: 0;
  //max-width: 453px;

  @media ${(props) => props.theme.breakpoints.lg} {
    padding: 2em 0 0 !important;
    max-width: 100%;
  }
`;

export const CMAuctionDescription = styled.div((props) => ({
  width: "40%",
  padding: "0 3%",

  "& > h4": {
    margin: 0,
    fontWeight: 500,
    fontFamily: props.theme.fontFamilies.workSans,
    // color: props.theme.palette.primary.main,
  },

  ".CMAuctionButtonDiv": {
    margin: "1rem 0",

    '& h1': { 
        fontSize:"36px",
        lineHeight: "1.0",
        marginBottom: "20px",
    },

    [`@media (min-width: 2000px)`]: {
      '& span': { 
        fontSize:"2vh"
      },
      '& h1': { 
        fontSize:"4vh"
      },
    },

    [`@media ${props.theme.breakpoints.xs}`]: {
      '& span': { 
        fontSize:"12px"
      },
      '& h1': { 
        fontSize:"18px"
      },
      '& > div': { 
        fontSize:"16px"
      },
    },
  },

  "& button": {
    marginTop: 0,
    marginRight: "0.6rem",
    color: props.theme.palette.gray["900"],
    borderRadius: 5,
    borderColor: "#D5D5D5",
    padding: "2px 1.80rem",

    "&:hover": {
      color: "#fff",
      backgroundColor: "#757575",
    },
  },
  ".CMAuctionGenereButton": {
    cursor: "default",
    marginBottom: 10,
    "&:hover": {
      color: props.theme.palette.gray["900"],
      backgroundColor: "none",
    },
  },
  [`@media (min-width: 2000px)`]: {
   ".CMAuctionButtonDivButton button": {
    fontSize:"2vh",
    },
  },

  [`${CMCardContainer}`]: {
    display: "none",
  },
  [`@media ${props.theme.breakpoints.lg}`]: {
    h1: {
      fontSize: props.theme.fontSizes.h2,
    },
    ".CMAuctionButtonDiv": {
      width:"100%",
      textAlign:"center"
    },
    ".CMAuctionButtonDivButton": {
      marginTop: "4%",
    },
    ".CMAuctionGenereButton": {
      marginBottom: 10,
    },
    [`${CMCardContainer}`]: {
      width: "100%",
      display: "block",
      position: "unset",
      marginTop: props.theme.spacers["5"],
      marginBottom: props.theme.spacers["7"],
      maxWidth: "unset",

      "& > div > div": {
        width: "95%",
      },
    },
  },
  [`@media ${props.theme.breakpoints.md}`]: {
    ".CMAuctionButtonDivButton": {
      marginTop: "4%",
    },
    ".CMAuctionGenereButton": {
      marginBottom: 10,
    },
  },
  [`@media ${props.theme.breakpoints.sm}`]: {
    ".CMAuctionButtonDivButton": {
      marginTop: "4%",
    },
    ".CMAuctionGenereButton": {
      marginBottom: 10,
    },
  },
  [`@media ${props.theme.breakpoints.xs}`]: {
    "& button": {
      marginRight: "0.6rem",
    },
    ".CMAuctionButtonDivButton": {
      marginTop: "5%",
    },
    ".CMAuctionGenereButton": {
      marginBottom: 10,
    },
  },
}));

export const CMDetails = styled.div((props) => ({
  display: "flex",
  position: "relative",
  marginTop: "80px",
  // paddingBottom: '40px',

  h1: {
    margin: 0,
  },

  '& .ContainerMobile':{
    width:"60%", 
    display:"flex",
    gap:"30px",

    [`@media ${props.theme.breakpoints.md}`]: {
      width:"70%", 
      justifyContent:"left",
    },

    [`@media ${props.theme.breakpoints.sm}`]: {
      width:"100%", 
      justifyContent:"left",
    },


  },

  [`@media ${props.theme.breakpoints.lg}`]: {
    flexDirection: "column",
    marginTop: 0,

    "& > div": {
      width: "100%",
      padding: 0,
    },
  },
}));

export const CMMedia = styled.div((props) => ({
  backgroundColor: props.theme.palette.gray["600"],

  "&": {
    paddingTop: "2rem",
  },

  "& h4": {
    margin: 0,
    [`@media (min-width: 2000px)`]: {
     fontSize:"4vh"
    },
  },
  "& p": {
    [`@media (min-width: 2000px)`]: {
     fontSize:"3vh"
    },
  },
  "& a": {
    [`@media (min-width: 2000px)`]: {
     fontSize:"4vh"
    },
  },

  "& > div > div": {
    padding: "2rem 0 0",

    "&:first-of-type": {
      padding: "1rem 0 0",
    },

  "&#noMedia": {
    "& > p": {
    margin: 0,
  },
  },
  },
}));

export const CMAuctionDetails = styled.div((props) => ({
  "& .back-arrow": {
    top: "20px",
    left: "100px",
  },

  [`${MainBox}`]: {
    position: "relative",
    paddingTop: props.theme.spacers.pageY,
    paddingBottom: props.theme.spacers.pageY,

    "&:first-of-type": {
      paddingTop: 0,
      [`@media (min-width: 3500px)`]: {
        paddingTop: "100px",
      },
    },
    "& .socialMediaAlign": {
      float: "right",
    
    },
  },

  h4: {
    fontWeight: 500,
  },

  "& .auction-financials": {
    backgroundImage: "unset !important",
    gap: "2em",

    [`@media (min-width: 770px)`]: {
      flexDirection: "row",
    },

    "& .dotted-border": {
      paddingTop: 0,
      backgroundImage: "unset !important",
    },
  },

  "@media(max-width: 1500px)": {
    "& .back-arrow": {
      left: "2%",
    },
  },

  [`@media ${props.theme.breakpoints.lg}`]: {
    h4: {
      paddingTop: 10,
      paddingBottom: 19,
    },

    "& .socialMediaAlign": {
      paddingTop: "2%",
      paddingLeft: "2%",
      float: "unset !important",
    },

    [`${CMHeadingContainer}`]: {
      width: "70%",
      paddingTop: "6%",
      paddingLeft: 0,
    },
    "& .scrollHeader": {
      display: "block",
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      background: "#fff",
      zIndex: 999,
      display: "flex",
      alignItems: "center",
      height: 55,
      borderTopStyle: "solid",
      borderColor: "#a80000",
      borderWidth: "thick",
      boxShadow: "0 6px 6px rgba(0, 0, 0, 0.1)",
      paddingRight: "2%",
      "& h4": {
        display: "flex",

        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        fontWeight: 500,
        textDecoration: "unset",
        color: "#000",
        fontFamily: props.theme.fontFamilies.workSans,
        "& span": {
          color: props.theme.palette.primary.main,
        },
      },
    },

    "& .scrollViewHeading": {
      paddingTop: 5,

      width: "100%",
    },

    "& .back-arrow": {
      top: 10,
      left: "5%",
    },
  },

  [`@media ${props.theme.breakpoints.md}`]: {
    "& .scrollViewHeading": {
      paddingRop: 5,
      width: "100%",
    },
    [`${CMHeadingContainer}`]: {
      width: "70%",
      paddingTop: "7%",
      paddingLeft: 0,
    },
    "& .back-arrow": {
      top: 10,
      left: "20px",
    },

    [`${CMHeadingContainer}`]: {
      width: "70%",

      "& > nav": {
        display: "flex",
        flexDirection: "row",
      },
    },
  },
  [`@media ${props.theme.breakpoints.sm}`]: {
   
    "& .scrollViewHeading": {
      paddingRop: 5,
      width: "100%",
    },
    [`${CMHeadingContainer}`]: {
      width: "70%",
      paddingTop: "7%",
      paddingLeft: 0,
    },
    "& .back-arrow": {
      top: 10,
      left: "20px",
    },

    [`${CMHeadingContainer}`]: {
      width: "70%",

      "& > nav": {
        display: "flex",
        flexDirection: "row",
      },
    },
  },
  [`@media ${props.theme.breakpoints.xss}`]: {
    [`${CMHeadingContainer}`]: {
      paddingTop: "12%",
      width:"100%"
    },
  },
}));

export const CMAuctionData = styled.div((props) => ({

  "& .tooltip-content": {
        display:"flex", 
        gap:"1vh",
        flex:1
  },
  
  "& > div": {
    display: "flex",
    marginTop: "8px",

    "& > div": {
      //paddingRight: "30%",
      marginLeft: "auto",

      "&:first-of-type": {
        width: "40%",
        paddingRight: "2rem",
        margin: "0",
      },
    },
  },

  [`@media (min-width: 2000px)`]: {
    '& h4': { 
      fontSize:"4vh !important"
    },
    '& div': { 
      fontSize:"2vh !important"
    },
  },

  [`@media ${props.theme.breakpoints.lg}`]: {
    "& > div": {
      "& > div:first-of-type": {
        width: "150px",
        paddingRight: "2rem",
      },
    },
  },

  [`@media (max-width: 992px)`]: {
    display: "none", 
  },
}));


